export default defineNuxtPlugin(async (nuxtApp) => {
  if (typeof window === 'undefined') return;

  const { setupForegroundPushListener, teardownForegroundPushListener, syncFcmTokenWithServer, ensureDeviceId } = await useFcm();

  ensureDeviceId();
  await setupForegroundPushListener();

  const syncWhenAuthenticated = async () => {
    const authToken = sessionStorage.getItem('token') || localStorage.getItem('token');
    if (!authToken) return;
    await syncFcmTokenWithServer({ forceSync: true });
  };

  const intervalId = window.setInterval(syncWhenAuthenticated, 5 * 60 * 1000);

  window.addEventListener('focus', syncWhenAuthenticated);

  await syncWhenAuthenticated();

  nuxtApp.hook('app:beforeUnmount', () => {
    teardownForegroundPushListener();
    window.removeEventListener('focus', syncWhenAuthenticated);
    clearInterval(intervalId);
  });
});
